import React, { ReactNode } from "react";
import styles from "./index.module.scss";
import clsx from "clsx";

export type buttonVariants = "primary" | "hollow" | "cancel" | "gray";

interface ILink {
  onClick?: () => void;
  content: ReactNode;
  className?: string;
  variant?: buttonVariants;
  disabled?: boolean;
  href: string;
  target: string;
}

export const Link: React.FC<ILink> = ({
  onClick,
  content,
  className = "",
  variant = "primary",
  disabled = false,
  href,
  target,
}) => {
  const varaintLink = {
    primary: styles.link__primary,
    hollow: styles.link__hollow,
    cancel: styles.link__cancel,
    gray: styles.link__gray,
  }[variant];
  return (
    <a
      className={clsx(
        styles.link,
        varaintLink,
        disabled && styles.link__disabled,
        className
      )}
      onClick={onClick}
      href={href}
      target={target}
    >
      {content}
    </a>
  );
};
